export default {
  noData: 'Sem mais dados',
  delConfirmTips: 'Tem certeza de que deseja excluir os dados selecionados?',
  delSuccess: 'Excluído com sucesso',
  tips: 'Dica',
  add: 'Adicionar',
  edit: 'Modificar',
  del: 'Excluir',
  editSuccess: 'Modificado com sucesso',
  activeAccount: 'Ativar conta',
  mailActiveSuccess: 'Conta ativada com sucesso',
  back: 'Voltar',
  goLogin: 'Ir para login',
  email: 'E-mail',
  emailSendSuccess: 'E-mail enviado com sucesso',
  paySuccess: 'Pagamento bem-sucedido',
  action: 'Operação',
  logoutSuccess: 'Logout bem-sucedido',
  plsUpload: 'Por favor, faça upload',
  upload: 'Upload',
  file: 'Arquivo',
  uploadFail: 'Falha no upload',
  uploadSuccess: 'Upload bem-sucedido',
  pay: 'Pagamento',
  day: 'Dia',
  servePrice: 'Taxa de serviço',
  skillServePrice: 'Taxa de serviço técnico',
  unitMonth: 'mês',
  num: 'Quantidade',
  photo: 'Foto',
  product: 'Produto',
  sizeHaveUnit: 'Dimensões(cm)',
  weightHaveUnit: 'Peso(g)',
  fee: 'Taxa',
  free: 'Grátis',
  submitTime: 'Hora de envio',
  weight: 'Peso',
  cancelReason: 'Motivo do cancelamento',
  submitPackage: 'Enviar pacote',
  submitSuccess: 'Enviado com sucesso',
  price: 'Preço',
  status: 'Status',
  noProduct: 'Sem produtos',
  backEdit: 'Voltar para modificar',
  errorHint: 'Erro de interface, por favor, solicite novamente',
  reload: 'Atualizar',
  reloadPageTips:
    'Sua conta foi alterada. Por favor, recarregue a página para obter informações atualizadas.',
  cancel: 'Cancelar',
  noMsg: 'Sem informações',
  totalAmount: 'Preço total',
  see: 'Ver',
  confirm: 'Confirmar',
  send: 'Enviar',
  nowNoInfo: 'Sem informações no momento',
  genderEnum: {
    0: 'Masculino',
    1: 'Feminino',
  },
  goEmailActiveTips: 'Por favor, vá para o e-mail para ativar a conta!',
  holder: {
    inputRemark: 'Por favor, insira o conteúdo da observação',
    inputExplainCancelReason: 'Por favor, explique o motivo do cancelamento',
    inputAddAddress: 'Por favor, adicione o endereço de entrega',
    inputMsg: 'Por favor, insira o conteúdo',
  },
  acceptMsg:
    'Este site armazena cookies em seu computador para fornecer uma melhor experiência. Para mais informações, consulte sua política de privacidade',
  accept: 'Aceitar',
  refuse: 'Recusar',
  notice: 'Atenção',
  noticeMsg: 'Nova linha de logística, redução de preço de 10%',
  english: 'Inglês',
  spanish: 'Espanhol',
  french: 'Francês',
  chinese: 'Chinês (Simplificado)',
  copySuccess: 'Copiado com sucesso',
  copyError: 'Falha ao copiar',
  noAgainShow: 'Não mostrar novamente',
  download: 'Download',
  downloadSuccess: 'Download bem-sucedido',
  uploadImgTips: 'Por favor, faça upload de arquivos JPG/PNG/WEBP/JPEG',
  noCheckAboutAgree: 'Não marcou concordar com o acordo relevante',
  country: 'País',
  collectSuccess: 'Favorito adicionado com sucesso!',
  cancelCollectSuccess: 'Favorito cancelado com sucesso!',
  formatError: 'Erro de formato, por exemplo: {formatStr}',
  volume: 'Volume (cm)',
  notRequired: 'Não obrigatório',
  productSaleCount: 'Vendas do produto',
  searchPlaceholder: 'Por favor, insira o conteúdo da pesquisa',
  THEME_MODE: 'Modo de tema',
  FOLLOW_SYSTEM: 'Seguir sistema',
  DAY_MODE: 'Modo diurno',
  NIGHT_MODE: 'Modo noturno',
}
